import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner,finishSpinner } from "./ui/spinner";
const urlBase= process.env.REACT_APP_URL

export const grupoFamiliarPreinscriptoTraerStart = () => ({ type: types.grupoFamiliarPreinscriptoTraerStart });
export const grupoFamiliarPreinscriptoDeleteFamiliar = () => ({ type: types.grupoFamiliarPreinscriptoDeleteFamiliar});
export const grupoFamiliarPreinscriptoTraerSuccess = (payload) => {
    return {
      type: types.grupoFamiliarPreinscriptoTraerSuccess,
      payload: payload
    }
  }
  
export const fetchGrupoFamiliarPreinscripto = (idAfiliado) => {
    return async (dispatch) => {
     dispatch(startSpinner());
        dispatch(grupoFamiliarPreinscriptoTraerStart());
      const response = await fetchConToken(`GrupoFamiliares/traerGrupoFamiliarPorIdPreafiliado/${idAfiliado}`);
      if (!response.ok) {
          //dispatch(grupofamiliarTraerError(response.statusText));
        throw Error(response.statusText);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {        
        const lista = await response.json();
        if (lista.length>0) {
          dispatch(grupoFamiliarPreinscriptoTraerSuccess(lista));
        }
      }
     dispatch(finishSpinner());
    };
  };

  export const fetchGrupoFamiliarPreinscriptoAutogestion = (idAfiliado) => {
    return async (dispatch,getState) => {
     dispatch(startSpinner());
     dispatch(grupoFamiliarPreinscriptoTraerStart());
     const state = getState();
      const {usuarioAutogestion} =  state.userAutogestion;
      fetch(`${urlBase}/api/GrupoFamiliares/traerGrupoFamiliarPorIdPreafiliado/${idAfiliado}`,{headers: {'Content-Type': 'application/json','Authorization':'Bearer '+usuarioAutogestion.token}})
      .then(res=>res.json())
      .then(res=>{
        if (res.status!==401) {
          dispatch(grupoFamiliarPreinscriptoTraerSuccess(res));
        }
      })
     dispatch(finishSpinner());
    };
  };


  export const grupoFamiliarDeleteFamiliar = (idAfiliado) => {
    return async (dispatch,getState) => {
     dispatch(startSpinner());
     const {afiliadoEncontrado} = getState().preinscripto;
      const response = await fetchConToken(`PreAfiliados/${idAfiliado}`,'','DELETE');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (lista.length>0) {
          dispatch(grupoFamiliarPreinscriptoDeleteFamiliar());
        }
      }
      dispatch(fetchGrupoFamiliarPreinscripto(afiliadoEncontrado.id_afiliado));
      dispatch(finishSpinner());
    };
  };
